import React, { createContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import toast from "react-hot-toast";

export const AuthContext = createContext();

// Environment Variables
export const base_url = process.env.REACT_APP_API_URL;
export const app_url = process.env.REACT_APP_APP_URL;
export const AGENTID = process.env.REACT_APP_AGENT_ID;
export const AGENTKEY = process.env.REACT_APP_AGENT_KEY;
export const REFERRERURL = process.env.REACT_APP_REFERRER_URL;
export const BASEURL = process.env.REACT_APP_BASE_URL;

export const AuthProvider = ({ children }) => {
  // Payment and Withdrawal Status Mappings
  const PaymentStatusMap = { PENDING: 0, SUCCESS: 1, CANCELLED: 2 };
  const WITHDRAWAL_STATUS_MAP = { PENDING: 0, APPROVED: 1, DENIED: 2 };

  // Helper function to get cookie value
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  };

  const loginstatus = getCookie("auth");
  const [isAuthenticated, setIsAuthenticated] = useState(!!loginstatus);

  // Inactivity Timer Setup
  const inactivityTimer = useRef(null);
  const INACTIVITY_TIME = 14 * 60; // 14 minutes

  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimer.current);
    inactivityTimer.current = setTimeout(() => {
      document.cookie = "token=; max-age=0; path=/;";
      document.cookie = "auth=; max-age=0; path=/;";
      setIsAuthenticated(false);
    }, INACTIVITY_TIME * 1000);
  };

  const startTracking = () => {
    ["mousemove", "keydown", "click", "scroll"].forEach((event) =>
      document.addEventListener(event, resetInactivityTimer)
    );
    resetInactivityTimer();
  };

  useEffect(() => {
    if (isAuthenticated) startTracking();
    return () => clearTimeout(inactivityTimer.current);
  }, [isAuthenticated]);

  // Register Function
  const Register = (data, callback) => {
    axios
      .post(`${base_url}/api/webapi/register`, data, {
        headers: { Accept: "application/json" },
      })
      .then((response) => callback(response.data))
      .catch((error) =>
        callback({
          status: false,
          message: error.data?.message || error.data?.message,
        })
      );
  };

  // Login Function
  const login = (data, callback) => {
    // console.log('lofinn',data);
    axios
      .post(`${base_url}/api/webapi/login`, data, {
        headers: { Accept: "application/json" },
      })
      .then((response) => {
        if (response.data.status) {
          const expiryDate = new Date();
          expiryDate.setTime(expiryDate.getTime() + 60 * 60 * 1000);
          const expires = "expires=" + expiryDate.toUTCString();

          document.cookie = `token=${response.data.token}; ${expires}; path=/;`;
          document.cookie = `auth=${response.data.value}; ${expires}; path=/;`;

          setIsAuthenticated(true);
          startTracking();
          callback(response.data);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) =>
        callback({
          status: false,
          message: error.response?.data?.message || error.message,
        })
      );
  };

  // Fetch User Data
  const userdata = async (callback) => {
    try {
      const response = await axios.post(
        `${base_url}/api/webapi/GetUserInfo`,
        {},
        { withCredentials: true, headers: { Accept: "application/json" } }
      );
      console.log('user data is',response)
      callback(response.data);
      return response.data;
    } catch (error) {
      console.error("User data error:", error.message);
      callback(null);
      return null;
    }
  };

  // Change Password
  const changepassword = (data, callback) => {
    const authdata = { ...data, auth: loginstatus };
    axios
      .post(`${base_url}/api/webapi/change/pass`, authdata)
      .then((response) => callback(response.data))
      .catch((error) =>
        callback({
          status: false,
          message: error.response?.data?.message || error.message,
        })
      );
  };

  // Logout Function
  const logout = () => {
    document.cookie = `token=; max-age=0; path=/;`;
    document.cookie = `auth=; max-age=0; path=/;`;
    setIsAuthenticated(false);
  };

  // Fetch Bank Details
  const getBankDetails = async () => {
    try {
      const response = await axios.get(
        `${base_url}/admin/manager/settings/get`,
        { withCredentials: true, headers: { Accept: "application/json" } }
      );

      return response.data.momo;
    } catch (error) {
      console.error("Bank details error:", error.message);
      return null;
    }
  };

  //fetch roles of logged in person
  const getRoles= async(auth, role)=> {
    try{
      const response= await axios.post(base_url+ '/api/webapi/admin/Rolelist',
        {},
        {
          headers:{
            Accept: 'application/json',
            Authorization: `${auth}`
          }
        }
      )

      const fullRoles= response.data.data;
      // console.log('full',fullRoles);

      const specifiedRole= fullRoles.filter((oneRole)=> Object.keys(oneRole).includes(role));

      return specifiedRole;
    }catch(err){
      console.log('err',err);
    }
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        PaymentStatusMap,
        WITHDRAWAL_STATUS_MAP,
        Register,
        login,
        logout,
        userdata,
        changepassword,
        getBankDetails,
        setIsAuthenticated,
        getRoles,
        base_url,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
